module.exports = __webpack_public_path__ + "static/lockheed-2efe1e95fb9865ffbcf61c4bd53c0b86.png";